import { fetchConfiguratorsRequest, selectRoughWorkNetwork } from 'containers/rough-work';
import { Store } from 'redux';
import { selectPageModelNetwork } from 'store/pageModel';
import { ErrorTypes, LoadDataReject } from 'types/load-data-reject-reason';

export const RoughWorkPageLoadData = (store: Store) =>
	new Promise<void>((resolve, reject: LoadDataReject) => {
		const pageModelNetwork = selectPageModelNetwork(store.getState());

		if (pageModelNetwork.isFetched && pageModelNetwork.isFailed) {
			return reject({ type: ErrorTypes.PAGE_MODEL, message: 'No page model data' });
		}

		store.dispatch(fetchConfiguratorsRequest());

		const unsub = store.subscribe(() => {
			const configuratorsNetwork = selectRoughWorkNetwork(store.getState());

			if (configuratorsNetwork.isFetched) {
				unsub();
				if (configuratorsNetwork.isFailed) {
					return reject({
						type: ErrorTypes.DATA,
						message: 'Rough configurators data was not fetched',
					});
				} else {
					return resolve();
				}
			}
		});
	});
